<dx-drop-down-box
[dataSource]="dataSources"
[value]="value"
[displayExpr]="'display'"
[readOnly]="readOnly"
[showClearButton]="false"
[valueExpr]="valueExpr" 
[deferRendering]="false"
[(opened)]="isOpen"
(onOpened)="onDropdownOpened()"
(onClosed)="onDropdownClosed()"
[focusStateEnabled]="true"
[labelMode]="isShowAccordion ? 'floating' : 'hidden'"
[label]="label"
[inputAttr]="{ 'aria-label': 'Owner' }"
>
<dx-text-box
  placeholder="Ara..."
  (onValueChanged)="searchDebounce($event)"
  valueChangeEvent="input"
  mode="search"
>
<dx-validator *ngIf="!validationV2">
  <dxi-validation-rule
    *ngFor="let rule of validationRul"
    [type]="rule?.type"
    [message]="rule?.message"
  ></dxi-validation-rule>
</dx-validator>
<dx-validator *ngIf="validationV2">
  <dxi-validation-rule
    *ngFor="let rule of validationRulesMap"
    [type]="rule?.type"
    [message]="rule?.message"
    [min]="rule?.min"
    [max]="rule?.max"
  >
  </dxi-validation-rule>
</dx-validator></dx-text-box>

<dx-list *ngIf="dataSources"
  [dataSource]="dataSources"
  displayExpr="display"
  selectionMode="single"
  (onItemClick)="onAutoCompleteValueChanged($event)"
></dx-list>

<span *ngIf="!dataSources">
  Veri bulunamadı
</span>
</dx-drop-down-box>